module.exports = __webpack_public_path__ + "static/media/checkWhite.c4091175.svg";